<div class="quiz-tab-content">
  <div class="table header">
    <mat-toolbar class="header-base" color="primary">
      <button mat-mini-fab color="white" (click)="addQuizText()">
        <mat-icon>add</mat-icon>
      </button>
    </mat-toolbar>
  </div>

  <div class="grid-container">
    <ng-container *ngFor="let text of texts; let indexOfelement = index">
      <div class="grid-item">
        <mat-card style="text-align: center">
          <div class="delete-container" (click)="remove(indexOfelement)">
            <mat-icon color="warn">delete</mat-icon>
          </div>
          <mat-card-content style="text-align: center">
            <ng-container class="lesson-name-content">
              <mat-form-field appearance="outline">
                <mat-label>Statement</mat-label>
                <input matInput [(ngModel)]="text.statement" />
                <button
                  *ngIf="text.statement"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="text.statement = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Right Answer</mat-label>
                <input matInput [(ngModel)]="text.rightAnswer" />
                <button
                  *ngIf="text.rightAnswer"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="text.rightAnswer = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Wrong Answer 1</mat-label>
                <input matInput [(ngModel)]="text.wrongAnswers[0]" />
                <button
                  *ngIf="text.wrongAnswers[0]"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="text.wrongAnswers[0] = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Wrong Answer 2</mat-label>
                <input matInput [(ngModel)]="text.wrongAnswers[1]" />
                <button
                  *ngIf="text.wrongAnswers[1]"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="text.wrongAnswers[1] = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Wrong Answer 3</mat-label>
                <input matInput [(ngModel)]="text.wrongAnswers[2]" />
                <button
                  *ngIf="text.wrongAnswers[2]"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="text.wrongAnswers[2] = ''"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Difficulty</mat-label>
                <mat-select [(ngModel)]="text.difficulty">
                  <ng-container *ngFor="let difficulty of difficulties">
                    <mat-option [value]="difficulty">{{
                      difficulty
                    }}</mat-option>
                  </ng-container>
                </mat-select>
                <button
                  *ngIf="text.difficulty"
                  matSuffix
                  mat-icon-button
                  aria-label="Clear"
                  (click)="text.difficulty = 1"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Is Grammar?</mat-label>
                <mat-select [(ngModel)]="text.isGrammar">
                  <mat-option [value]="false">No</mat-option>
                  <mat-option [value]="true">Yes</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Text</mat-label>
                <textarea matInput [(ngModel)]="text.text"></textarea>
              </mat-form-field>
            </ng-container>
          </mat-card-content>
        </mat-card>
      </div>
    </ng-container>
  </div>
</div>
